import { UserAvatarSize } from '@solvace/component/svc-user-avatar';

export enum UserAvatarType {
  user = 1,
  team = 2,
}

export interface ISvcAvatarMultiple {
  size: UserAvatarSize;
  initialsColor?: string;
  type?: UserAvatarType;
  data: ISvcAvatar[];
}

export interface ISvcAvatar {
  name: string;
  picture?: string;
  pictureHQ?: string;
  initialsColor: string;
  type: number;
}
